import { FC, ReactNode, ComponentProps } from 'react'
import { useCollections } from '@reservoir0x/reservoir-kit-ui'
import { SWRResponse } from 'swr'
import { Button } from 'components/primitives'
import { CSS } from '@stitches/react'

type Props = {
  collection: NonNullable<ReturnType<typeof useCollections>['data']>[0]
  mutate?: SWRResponse['mutate']
  buttonCss?: CSS
  buttonChildren?: ReactNode
  buttonProps?: ComponentProps<typeof Button>
}

// PARKED: trading execution is paused during the Alchemy migration.
const CollectionOffer: FC<Props> = () => {
  // HIDDEN during the browse-only relaunch: native trading is parked, so these
  // controls render nothing. Buying happens via the OpenSeaButton outbound link.
  // To restore, render <TradePausedButton .../> again in the component body below.
  return null
}

export default CollectionOffer
